// ─── DOMAINS ─────────────────────────────────────────────────────────────────
// Source: Section 4 — 6 Domains with Adaptive Intelligence (updated document)
// NOTE: Cybersecurity removed. Absentee Ballot is now Domain 6 (HIGH PRIORITY).

export const DOMAINS = [
  {
    id: 1,
    name: "Poll Worker Management",
    shortName: "Poll Workers",
    icon: "👥",
    color: "#005d9e",
    colorRgb: "0,93,158",
    coreQCount: 3,
    adaptiveQRange: "0–5",
    strategicGoal: "Expose coordination chaos",
    description: "Streamlines recruitment, scheduling, training, and tracking of poll workers",
    product: "Poll Worker Management",
    weight: "Standard",
    pointsRange: "12–20",
  },
  {
    id: 2,
    name: "Election Asset Management",
    shortName: "Asset Management",
    icon: "🗳️",
    color: "#7c3aed",
    colorRgb: "124,58,237",
    coreQCount: 4,
    adaptiveQRange: "0–5",
    strategicGoal: "Reveal visibility gaps",
    description: "Manages voting equipment, consumables, logic & accuracy testing workflows",
    product: "Election Asset Management",
    weight: "Standard",
    pointsRange: "15–25",
  },
  {
    id: 3,
    name: "Policy AI / Legal Response",
    shortName: "Policy AI",
    icon: "⚖️",
    color: "#16a34a",
    colorRgb: "22,163,74",
    coreQCount: 2,
    adaptiveQRange: "0–5",
    strategicGoal: "Show legal delay costs",
    description: "AI-powered chatbot providing instant answers on election laws and regulations",
    product: "Policy AI",
    weight: "Standard",
    pointsRange: "8–15",
  },
  {
    id: 4,
    name: "Election Help Desk",
    shortName: "Election Help Desk",
    icon: "🎧",
    color: "#005d9e",
    colorRgb: "0,93,158",
    coreQCount: 4,
    adaptiveQRange: "0–5",
    strategicGoal: "Surface issue tracking failures",
    description: "Ticketing and help desk system for election operations teams",
    product: "Support IQ",
    weight: "Standard",
    pointsRange: "8–15",
  },
  {
    id: 5,
    name: "Analytics & FOIA Readiness",
    shortName: "Analytics & FOIA",
    icon: "📊",
    color: "#e20612",
    colorRgb: "226,6,18",
    coreQCount: 2,
    adaptiveQRange: "0–5",
    strategicGoal: "Expose transparency gaps",
    description: "Finance-based analytics on voter data and FOIA/Open Records management",
    product: "Analytics Hub",
    weight: "Standard",
    pointsRange: "6–10",
  },
  {
    id: 6,
    name: "Absentee Ballot Portal",
    shortName: "Absentee Ballot",
    icon: "📬",
    color: "#ea580c",
    colorRgb: "234,88,12",
    coreQCount: 3,
    adaptiveQRange: "0–5",
    strategicGoal: "Legal/public risk — compliance wedge",
    description: "End-to-end absentee ballot management: intake, verification, tracking, curing workflows",
    product: "Absentee Ballot Portal",
    weight: "Standard",
    pointsRange: "11–20",
    premium: false,
    highPriority: true,
    complianceWedge: true,
  },
  {
    id: 7,
    name: "Voter AI",
    shortName: "Voter AI",
    icon: "🤖",
    color: "#d97706",
    colorRgb: "217,119,6",
    coreQCount: 2,
    adaptiveQRange: "0–5",
    strategicGoal: "Automate voter engagement and guidance",
    description: "AI-powered real-time voter guidance, polling location lookup, and automated procedure dissemination",
    product: "Voter AI",
    weight: "Standard",
    pointsRange: "10–15",
  },
];

export const getDomain = (id) => DOMAINS.find((d) => d.id === id);
